module.exports = __webpack_public_path__ + "img/default_avatar.bb9ccd92.png";